import { Link } from 'react-router-dom';
import { useGoogleButton } from '../hooks/useGoogleButton';

import { useLoginForm } from '../hooks/useLoginForm';
import { useRegisterForm } from '../hooks/useRegisterForm';

type AuthLayoutProps = {
  page: 'login' | 'register';
  isGoogleCallbackLoading?: boolean;
};

export const AuthLayout = ({ page, isGoogleCallbackLoading }: AuthLayoutProps) => {
  const isLoginPage = page === 'login';

  const { GoogleBtn } = useGoogleButton(isLoginPage);

  const { LoginForm } = useLoginForm(isGoogleCallbackLoading);
  const { RegisterForm } = useRegisterForm();

  return (
    <div className="flex flex-col items-center w-full mt-3 md:mt-12">
      <h1 className="text-3xl md:text-5xl font-bold">{isLoginPage ? 'Sign in' : 'Register'}</h1>
      <div className="flex mt-8 flex-col gap-4 items-center w-full md:w-[25rem]">
        {GoogleBtn}
        <div className="flex items-center gap-3 w-full">
          <div className="w-full h-[1px] bg-cyan-300"></div>
          <p>OR</p>
          <div className="w-full h-[1px] bg-cyan-300"></div>
        </div>
        {page === 'login' ? LoginForm : RegisterForm}
        <div className="w-full text-center text-sm">
          {isLoginPage ? (
            <p>
              Don't have an account?{' '}
              <Link className="font-bold text-cyan-800" to="/register">
                Register
              </Link>
            </p>
          ) : (
            <p>
              Already have an account?{' '}
              <Link className="font-bold text-cyan-800" to="/login">
                Login
              </Link>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
